import type { DocumentTaskFromResponse } from 'shared/features/workflow/workflow.types';
import type { AttachmentsCellAttachment } from '../../CommonCells';

export const formatAttachments = (
  documentTask: DocumentTaskFromResponse
): AttachmentsCellAttachment[] => {
  return documentTask.attachments.map(attachment => ({
    url: attachment.url,
    userFileName: attachment.user_file_name
  }));
};
